import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

interface BackButtonProps {
  onClick: () => void;
}

export function LargeArrowBackButton({ onClick }: BackButtonProps) {
  return (
    <StyledBackButton onClick={onClick}>
      <FontAwesomeIcon icon={faArrowLeft} />
    </StyledBackButton>
  );
}

const StyledBackButton = styled.button`
  align-items: center;
  background: var(--wbs-red);
  border: none;
  border-radius: 50%;
  box-shadow: 1px 1px 2px rgba(34, 34, 34, 0.5);
  color: var(--white);
  cursor: pointer;
  display: flex;
  font-size: 33px;
  height: 50px;
  justify-content: center;
  position: absolute;
  right: -16px;
  top: -16px;
  transition: all 0.2s ease;
  width: 50px;

  &:hover {
    background: var(--white);
    color: var(--wbs-red);
  }
`;
